import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from '@layout/main/main-layout.component';

const routes: Routes = [
  {
    path: ':id',
    redirectTo: ':id/details',
    pathMatch: 'full'
  },
  {
    path: ':id',
    component: MainLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('@module/index/index.module').then(m => m.IndexModule) }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { 
    scrollPositionRestoration: "enabled",
    // enableTracing: true,
  })],
  exports: [RouterModule]
})
export class LayoutRoutingModule { }
